import axios from 'axios';

export default {
    listCustomersForRoute(routeId) {
        return axios.post('/customer/listCustomersForRoute', { routeId });
    },
    listCustomers(payload) {
        return axios.post('/customer/listCustomers/', payload);
    },
    customerForOrder(orderId, customFields) {
        return axios.post('/customer/customerForOrder/', {
            orderId,
            customFields,
        });
    },
};
